// import Button from "../common/Button/Button";
import classes from "./About.module.css";
import about from "./admin.jpg";

const About = () => {
  return (
    <>
      <section id="about" className={classes.aboutSec}>
        <div className={classes.about}>
          <div className={classes.details}>
            <h3 className={classes.heading}>About</h3>
            <h2 className={classes.heading1}>TEKNODEON</h2>
            <p className={classes.para}>
            While the present can be considered as unprecedented at its best, KITS provides a platform to showcase your talents as a surety. Presenting to you the Third edition of the Technical festival <strong>TEKNODEON.</strong> <strong>Teknodeon-</strong> A nexus of Innovation, Creativity and Entertainment, is a 3-day National level Technical Fest organized by KITS, Ramtek which aims to encourage students to think beyond academics and helps them discover their hidden passions and talents. This technical extravaganza gives space for students to flaunt their skills in various domains and caters to their adrenaline surges.
<br/>
<br/>
<strong>6th March to 8th March</strong>- Save the dates. <strong>Teknodeon-</strong> Genesis of the Future.
            </p>

            {/* <p className={classes.para}>
            Spectacular talent stretches boundaries to inspire the participating
            students and the rapt audience alike. A gigantic range of events
            from advanced robotics challenges to entrepreneurship hunts
            promising to zap up the cranial indices of participants. Skill,
            genius and knowledge trading infused with a handful of fun, and a
            titanic prize money sum of above half a million rupees to make Karma
            one of the most unique tech carnivals of the country.
          </p> */}
            {/* <div className={classes.btn}>
            <Button label="Explore" />
          </div> */}
          </div>

          <div className={classes.composition}>
            <img className={classes.images} src={about} alt="about" />
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
